import React, { useState } from "react";
import { Modal, Button, Row, Col, Container } from "react-bootstrap";
import style from "../Modal.module.scss";
import { TODIS_FORM_FIELD } from "../../Forms";
import { Formik, Form } from "formik";
import { TODIS_KPI_RANGE_INIT, TODIS_KPI_RANGE_VALID } from "../../../.config/KPI/modal_KPI";
import { BsArrowRight, BsExclamationCircleFill } from "react-icons/bs";
import { TODIS_DATEPICKER } from "../../Buttons";

const TODIS_MODAL_KPI_RANGE = ({onCalculate, ...props}) => {
    

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            contentClassName={style.todisModalContainer}
            className={style.todisModalContainer}
        >
            <Modal.Header closeButton className={style.modalHeader}>
                <Modal.Title id="contained-modal-title-vcenter" className={style.modalTitle}>
                    {props.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Formik
                            initialValues={TODIS_KPI_RANGE_INIT}
                            validationSchema={TODIS_KPI_RANGE_VALID}
                            onSubmit={(values) => onCalculate(values)}>
                            {({ errors, touched }) => (
                                <Form className="todis-form-content">
                                    <Row>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="fromData" name="fromData" label="From Data"/>
                                            {errors.fromData && touched.fromData ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20}/></span>Error: {errors.fromData}</div>) : null}
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="toData" name="toData" label="To Data"/>
                                            {errors.toData && touched.toData ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20}/></span>Error: {errors.toData}</div>) : null}
                                        </Col>
                                    </Row>
                                    <div className="todis-action-form">
                                        <Button variant="outline-danger" onClick={() => props.onHide()} className={style.todisBtnOutline}>DISCARD </Button>
                                        <Button variant="primary" className="todis-submit-btn bck-btn-secundary" style={{margin: "0.5rem"}} type="submit">CALCULATE</Button>
                                    </div>
                                </Form>
                            )}
                    </Formik> 
                </Container>  
            </Modal.Body>
        </Modal>
    )
}

export { TODIS_MODAL_KPI_RANGE };